// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "body{margin:0;padding:0}.queue-list-header th.col{font-size:1.042vw;background:#eee;color:#684624}.col{font-size:.833vw}", ""]);
// Exports
module.exports = exports;
